module.exports = __webpack_public_path__ + "static/human-centered-design-3544ea710b8e27dae5f50ddcebccc820.jpg";